export default __webpack_public_path__ + "static/media/gb-eng.c0f1c901.svg";